'use strict';

/**
 * CDN URL for this directive --> ${jsCdnHost}/__assets__/scripts/jhire/directives/requisitions/jv.ChooseAddReqsFormDirective.js?v=${fileVersion}
 * One you have this directive imported successfully follow below instructions to use it.
 * Scope variables used in this directive:
 *    showChooseReqsFormModal -> once the directive is added in your html file, 
 *                               just set this variable to true inside the controller scope which is being shared in this directive also and modal will be displayed
 *    addRequisitionsUrl -> This is URL value in which template id will be appended as a parameter and page will be redirected to this url. 
 *                          If not passed, default value will be taken as 'add.html'. Hence this 'add.html' will be added as relative path
 */
angular.module('jv.choose.add.reqs.form.directive', [])
  .directive('chooseAddReqsForm', [
    '$window',
    'chooseAddReqsFormService',
    '$log',
    function ($window, chooseAddReqsFormService, $log) {
      return {
        restrict: 'E',
        link: function ($scope, element, attribute) {

          $scope.requisitionTemplates = [];
          $scope.filteredTemplates = [];
          $scope.flags = $scope.flags || {};
          $scope.flags.loading = true;
          $scope.isDashboardPage = location.pathname.indexOf('dashboard') !== -1;

          $scope.formData = {
            templateId: -1,
            sortBy: {
              header: 'templateName',
              direction: 'asc'
            },
            pagination: {
              currPage: 0,
              recordsPerPage: 10,
              totalPages: 0
            },
            searchKeyword: ''
          };

          $scope.requisitionTemplatesUIObject = [
            {
              key: 'templateName',
              'class': 'col-5',
              labelKey: 'COMMON.NAME'
            },
            {
              key: 'description',
              'class': 'col-6',
              labelKey: 'COMMON.DESCRIPTION'
            },
            {
              key: 'add',
              'class': 'col-1 reqs-add-button float-right',
              labelKey: 'COMMON.ADD'
            }
          ];

          $scope.addReqsUsingSelectedTemplate = function () {
            $window.location.replace(($scope.addRequisitionsUrl || $window.jvUrls.jhire+'/modules/requisitions/add.html') + '?templateId=' + $scope.formData.templateId);
          };

          // pagination methods
          $scope.hasNext = function () {
            return ($scope.formData.pagination.currPage < $scope.formData.pagination.totalPages);
          };

          $scope.hasPrevious = function () {
            return ($scope.formData.pagination.currPage > 1);
          };
          
          $scope.showingLowerRange = function () {
            return ($scope.formData.pagination.currPage - 1) * $scope.formData.pagination.recordsPerPage + 1;
          };

          $scope.showingUpperRange = function () {
            return Math.min($scope.showingLowerRange() - 1 + $scope.formData.pagination.recordsPerPage, $scope.filteredTemplates.length);
          };

          $scope.onPaginationChange = function (num) {
            $scope.formData.pagination.currPage += num;
            var currPage = $scope.formData.pagination.currPage;
            if (currPage < 1 || currPage > $scope.formData.pagination.totalPages) {
              $scope.initializePagination();
            }
          };

          $scope.initializePagination = function () {
            $.extend($scope.formData.pagination, {
              currPage: 1,
              totalPages: Math.ceil($scope.filteredTemplates.length / $scope.formData.pagination.recordsPerPage)
            });
          };

          $scope.$watch('formData.searchKeyword', function (newValue, oldValue) {
            $scope.filteredTemplates = $scope.$eval('requisitionTemplates | filter:{ templateName: formData.searchKeyword }');
            if (newValue !== oldValue) {
              $scope.initializePagination();
            }
          });

          chooseAddReqsFormService.getRequisitionTemplates($scope.formData)
            .then(function (res) {
              $scope.requisitionTemplates = res.reqTemplates;
              $scope.filteredTemplates = res.reqTemplates;
              $scope.flags.loading = false;
              $scope.initializePagination();
            }, function (err) {
              $log.error('Error fetching requisition templates', err);
            });
        },
        templateUrl: '/jhire/modules/requisitions/chooseAddReqsFormTemplate.html'
      };
    }
  ])
  .factory('chooseAddReqsFormService', [
    '$window',
    '$http',
    '$q',
    '$log',
    function ($window, $http, $q, $log) {
      var chooseAddReqsFormService = {};

      /**
       * @returns This returns all the available templates for the company.
       */
      chooseAddReqsFormService.getRequisitionTemplates = function (formData) {
        return $http.get($window.jvUrls.jhire + '/action/requisition/templates?maxResults=-1&sortBy=' + formData.sortBy.header)
          .then(function (res) {
            return (res && res.data) || $q.reject();
          }, function (err) {
            $log.warn('Error occurred when calling templates service', err);
            return {};
          });
      };
      return chooseAddReqsFormService;
    }
  ])
  .filter('paginateTemplates', [
    function () {
      return function (input, paginationData) {
        var startIndex = (paginationData.currPage - 1) * paginationData.recordsPerPage;
        var endIndex = startIndex + paginationData.recordsPerPage;
        return input.slice(startIndex, endIndex);
      };
    }
  ]);
